<script>
    import { Tooltip } from 'sveltestrap';

    export let inmateUrn;
    export let targeted;
    export let targetedTotal;
    export let inmateLabel;
</script>

<td>
    {#if targeted}
        {#if targetedTotal > 1}
            <img id="inmate-targeted-multiple-{inmateUrn}" src="/assets/target-indicator-danger.svg" alt="{inmateLabel} is targeted on {targetedTotal} aspects" />
            <Tooltip target="inmate-targeted-multiple-{inmateUrn}" placement="bottom">{inmateLabel} is targeted on multiple aspects</Tooltip>
        {:else}
            <img id="inmate-targeted-{inmateUrn}" src="/assets/target-indicator.svg" alt="{inmateLabel} is targeted on this aspect" />
            <Tooltip target="inmate-targeted-{inmateUrn}" placement="bottom">{inmateLabel} is targeted on this aspect</Tooltip>
        {/if}
    {/if}
</td>